/**
 * User UI Components Exports
 */

export { ProfileHeader } from './ProfileHeader';
export { ProfileTabs } from './ProfileTabs';
export type { ProfileHeaderProps } from './ProfileHeader';

export { ProfileBio } from './ProfileBio';
export type { ProfileBioProps } from './ProfileBio';

export { FormInput } from './FormInput';

export { ProfilePortfolio } from './ProfilePortfolio';
export type { ProfilePortfolioProps } from './ProfilePortfolio';

export { Reviews } from './Reviews';
export type { ReviewsProps } from './Reviews';

export { Review } from './Review';
export type { ReviewProps } from './Review';

export { ProfileOrders } from './ProfileOrders';
export type { ProfileOrdersProps, Order } from './ProfileOrders';

export { ProfileSettings } from './ProfileSettings';
export type { ProfileSettingsProps } from './ProfileSettings';

// Re-export types for convenience
export type { ContractorProfile } from '@hummii/shared-types';
export type { ProfileReview } from '../types';
